export default __webpack_public_path__ + "static/media/banking_information_icon.6e58b0e0.svg";